<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">
        {{ $t("receipts") }} {{ $t("templates") }}
      </div>
      <!-- <router-link class="btn-blue" to="add-receipts-template">{{ $t('add') }}</router-link> -->
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div v-if="TemplateList.length > 0" class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'rtemp_name'"
                @click="onSortValue('rtemp_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('rtemp_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('rtemp_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("receipts") }} {{ $t("templates") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(templatedata, templatedataIndex) in TemplateList"
            :key="templatedataIndex"
            @mouseleave="hoveredTemplateId = null"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end"> -->
            <!-- <label class="ios-switch">
                  <input
                    :checked="templatedata.rtemp_is_active == 'Y'"
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
            <!-- <StatusDot
                  :status="
                    templatedata.rtemp_is_active == 'Y'
                      ? 'active'
                      : templatedata.rtemp_is_active == 'Y' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4"> -->
            <!-- to="edit-ticket-templates -->
            <!-- <b-dropdown-item v-on:click="onTicketTemp('Edit', templatedata.rtemp_id)">
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>-->
            <!-- to="view-ticket-templates -->
            <!-- <b-dropdown-item
                    v-on:click="onTicketTemp('View', templatedata.rtemp_id)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    templatedata.rtemp_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />
                <div
                  class="ml-4 clickable-icon"
                  @click="onTicketTemp('View', templatedata.rtemp_id)"
                  @mouseenter="onHoverTemplate(templatedata.rtemp_id, $event)"
                  @mouseleave="hoveredTemplateHtml = null"
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              </div>
            </td>
            <td>{{ templatedata.rtemp_name }}</td>
          </tr>
        </tbody>

        <div
          v-if="hoveredTemplateHtml"
          class="animated revealUp floating-tooltip"
          :style="{
            top: tooltipPosition.top + 'px',
            left: tooltipPosition.left + 'px',
          }"
        >
          <div class="all-details-container">
            <div class="row justify-content-center">
              <div v-html="hoveredTemplateHtml"></div>
            </div>
          </div>
        </div>
      </table>

      <b-pagination
        v-if="TemplateList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      TemplateList: [],
      hoveredTemplateId: null,
      hoveredTemplateHtml: null,
      tooltipPosition: { top: 0, left: 0 },

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getReceiptTemplateList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onHoverTemplate(rtemp_id, event) {
      let payload = {
        rtemp_id,
        flag: "View",
      };

      MasterService.GetSingleReceiptTemplate(payload).then((response) => {
        if (response.data) {
          this.hoveredTemplateHtml = response.data;

          const iconRect = event.target.getBoundingClientRect();
          const tooltipWidth = 300;
          const offset = -10;
          const leftOffset = -50;
          this.tooltipPosition = {
            top: iconRect.top + window.scrollY - offset,
            left: Math.min(
              iconRect.left + window.scrollX,
              window.innerWidth - tooltipWidth - leftOffset
            ),
          };
        }
      });
    },
    hoveredTemplateHtml() {
      this.hoveredHTML = null;
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getReceiptTemplateList();
      } else {
        this.currentPage = event;
        this.getReceiptTemplateList();
      }
    },
    onTicketTemp: function (type, id) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-receipts-template",
          query: { rtemp_id: id },
        });
      } else {
        this.$router.push({
          path: "/master/view-receipts-template",
          query: { rtemp_id: id },
        });
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getReceiptTemplateList();
    },

    getReceiptTemplateList: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };
      MasterService.GetReceiptTemplate(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.floating-tooltip {
  position: fixed;
  width: auto;
  height: auto;
  max-height: 700px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
  overflow-y: auto;
  pointer-events: none;
  /* transform: scale(0.4);  */
  transform-origin: top left;
}
.animated.revealUp {
  animation: revealUp 0.3s ease-in-out;
}

@keyframes revealUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.all-details-container {
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px;
  margin-top: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReceiptsTemplate/receiptsTemplate.vue